import { ADDRESS_CITY_FIELD } from '@glass/web/modules/payments/paymentFormFields';
import { selectPaymentFormValue } from '@glass/web/modules/resumes/selectors';

const selectPaymentFormCity = (state) =>
  selectPaymentFormValue(state)?.[ADDRESS_CITY_FIELD] || null;

export default selectPaymentFormCity;
